export const getWorkflowTypeKey = (workflowType = {}) => workflowType.id ?? workflowType.uuid;
